import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Container",
    component: TheContainer,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          label: label.page.dashboard,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/Home"),
      },
      {
        path: "profile",
        name: "Profile",
        meta: {
          label: label.page.profile,
          requiresAuth: false,
        },
        component: () => import("@/views/auth/Profile"),
      },
      {
        path: "base",
        name: "BaseInformations",
        meta: {
          label: label.page.baseInformation,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/base"),
      },
      {
        path: "users",
        name: "Users",
        meta: {
          label: label.page.users,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/users"),
      },
      {
        path: "aboutus",
        name: "AboutUsPage",
        component: () => import("@/views/pages/other/AboutView"),
      },
      {
        path: "blog",
        name: "BlogsList",
        component: () => import("@/views/pages/blogs/List.vue"),
      },
      {
        path: "blog/:id/:title",
        name: "BlogDetails",
        component: () => import("@/views/pages/blogs/Details.vue"),
      },
      {
        path: "contactus",
        name: "ContactUsPage",
        component: () => import("@/views/pages/other/ContactView.vue"),
      },
      {
        path: "faq",
        name: "Faq",
        component: () => import("@/views/pages/other/Faq.vue"),
      },
      {
        path: "tutorials",
        name: "TutorialsList",
        component: () => import("@/views/pages/tutorials/List.vue"),
      },
      {
        path: "tutorial/:id/:title",
        name: "TutorialDetails",
        component: () => import("@/views/pages/tutorials/Details.vue"),
      },
      {
        path: "products",
        name: "ProductsList",
        component: () => import("@/views/pages/products/List.vue"),
      },
      {
        path: "product/:id/:title",
        name: "ProductDetails",
        component: () => import("@/views/pages/products/Details.vue"),
      },
      {
        path: "support",
        name: "supportPage",
        component: () => import("@/views/pages/support/index.vue"),
      },
      {
        path: "rules",
        name: "RulesPage",
        meta: {
          label: label.page.rules,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/other/Rules.vue"),
      },
      {
        path: "cooperation",
        name: "cooperationPage",
        meta: {
          label: label.page.cooperation,
          requiresAuth: false,
        },
        component: () => import("@/views/pages/cooperation/Index.vue"),
      },
      {
        path: "/services/:id/:title",
        name: "servicePage",
        component: () => import("@/views/pages/services/details.vue"),
      },
      {
        path: "/page",
        redirect: "/page/list",
        name: "Page",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: ":key",
            name: "DynamicPage",
            component: () => import("@/views/pages"),
          },
        ],
      },
      {
        path: "/gallery",
        redirect: "/gallery/list",
        name: "Gallery",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        children: [
          {
            path: "list",
            name: "GalleryList",
            component: () => import("@/views/pages/gallery/List.vue"),
          },
          {
            path: "image/:id/:title",
            name: "ImageGallery",
            component: () => import("@/views/pages/gallery/ImageGallery"),
          },
          {
            path: "video/:id/:title",
            name: "VideoGallery",
            component: () => import("@/views/pages/gallery/VideoGallery"),
          },
          {
            path: "sound/:id/:title",
            name: "SoundGallery",
            component: () => import("@/views/pages/gallery/SoundGallery"),
          },
        ],
      },
    ],
  },

  // other Pages - without container
  {
    path: "/login",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    // beforeEnter(to, from, next) {
    //   GlobalGuards.login(to, from, next);
    // },
  },
  {
    path: "/register",
    name: "Register",
    meta: {
      label: label.page.register,
    },
    component: () => import("@/views/auth/Register"),
    // beforeEnter(to, from, next) {
    //   GlobalGuards.login(to, from, next);
    // },
  },

  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
